import { CSSProperties } from "react";
import Image from "next/image";
import { FlexRowAlignCenter } from "@/components/Flex";

type GenericPlaceholderProps = {
    text: string;
    icon: string;
    imgAlt: string;
    height?: CSSProperties["height"];
    containerStyle?: CSSProperties;
};

const GenericPlaceholder = ({ text, icon, imgAlt, height = "3.5rem", containerStyle }: GenericPlaceholderProps) => (
    <FlexRowAlignCenter style={{ height, ...containerStyle }}>
        <Image src={icon} alt={imgAlt} width={20} height={20} />
        <span
            style={{ marginLeft: "0.8rem", color: "#c3c3c3", fontSize: "2rem", fontWeight: "700" }}
            data-testid="auto-id-9d0a65dc-009f-4ea3-ae3e-13378b615a83">
            {text}
        </span>
    </FlexRowAlignCenter>
);

export default GenericPlaceholder;
